import { render, staticRenderFns } from "./serverConfig.vue?vue&type=template&id=508a3efc"
import script from "./serverConfig.vue?vue&type=script&lang=js"
export * from "./serverConfig.vue?vue&type=script&lang=js"
import style0 from "./serverConfig.vue?vue&type=style&index=0&id=508a3efc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports